import React, { useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";
import { PUNE_CENTER, AREA_COORDS } from "../data/puneAreas";
import { inr } from "../api";

const pinIcon = (label) =>
  L.divIcon({
    className: "mpp-pin",
    html: `<div style="background:#f2620f;color:#fff;padding:4px 8px;border-radius:9999px;font:600 12px 'Space Grotesk',sans-serif;white-space:nowrap;box-shadow:0 2px 6px rgba(0,0,0,.3);border:2px solid #fff;text-align:center">${label}</div>`,
    iconSize: [86, 26],
    iconAnchor: [43, 26],
    popupAnchor: [0, -26],
  });

// Place first listing of an area at its centroid; ring-offset only duplicates.
function computePositions(properties) {
  const byArea = {};
  properties.forEach((p) => {
    (byArea[p.area] = byArea[p.area] || []).push(p.id);
  });
  const pos = {};
  properties.forEach((p) => {
    const base = AREA_COORDS[p.area] || PUNE_CENTER;
    const group = byArea[p.area];
    const idx = group.indexOf(p.id);
    if (group.length === 1 || idx === 0) {
      pos[p.id] = base;
    } else {
      const angle = idx * 2.399;
      const radius = 0.008 * Math.ceil(idx / 6) + 0.008;
      pos[p.id] = [base[0] + radius * Math.cos(angle), base[1] + radius * Math.sin(angle)];
    }
  });
  return pos;
}

export default function PropertiesMap({ properties }) {
  const positions = useMemo(() => computePositions(properties), [properties]);
  return (
    <div className="rounded-2xl overflow-hidden border border-neutral-200 shadow-card" data-testid="properties-map">
      <MapContainer center={PUNE_CENTER} zoom={11} style={{ height: "560px", width: "100%" }} scrollWheelZoom>
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {properties.map((p) => (
          <Marker key={p.id} position={positions[p.id]} icon={pinIcon(inr(p.price))}>
            <Popup>
              <div style={{ minWidth: 180 }}>
                <img src={p.image} alt="" style={{ width: "100%", height: 90, objectFit: "cover", borderRadius: 8 }} />
                <div style={{ fontWeight: 700, color: "#122a63", marginTop: 6 }}>{p.title}</div>
                <div style={{ color: "#f2620f", fontWeight: 700 }}>{inr(p.price)} · {p.listing_type}</div>
                <div style={{ color: "#666", fontSize: 12 }}>{p.area}, {p.city}</div>
                <Link to={`/properties/${p.id}`} style={{ color: "#f2620f", fontWeight: 600, fontSize: 13 }}>View details →</Link>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
